import { makeStyles } from '@mui/styles';
import { theme } from '~/theme/default';
export const useStyles = makeStyles(() => ({
    activeItem: {
        '&.MuiTypography-root': {
            color: theme.palette.text.secondary,
        },
    },
}));
